import React, { Component } from "react";
import "./input.css";
import Prev from "../assets/button/previous.png";
import Next from "../assets/button/next.png";

class Input extends Component {
  state = {};
  render() {
    return (
      <div className="Rectangle-Copy-2">
        <div className="text">Name</div>
        <div className="Rectangle" />
        <div className="text">Date of Birth</div>
        <div className="Rectangle" />
        <div className="text">Email Address</div>
        <div className="Rectangle" />
        <div className="text">Address</div>
        <div className="Rectangle" />
        <div className="text">Gender</div>
        <div className="Rectangle" />
        <div className="text">Nationality</div>
        <div className="Rectangle" />
        <div className="row btnss">
          <div className="col">
            <img src={Prev} alt="" className="img-fluid" />
          </div>
          <div className="col">
            <img src={Next} alt="" className="img-fluid" />
          </div>
        </div>
      </div>
    );
  }
}

export default Input;
